import { Component, OnInit, ViewChild, ElementRef, Inject, Output, EventEmitter, OnDestroy } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { NgbModalRef, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { TranslateService } from '@ngx-translate/core';

const nocUtil = require('../../../../../../noc/util/noc-util');

@Component({
  selector: 'app-sim-consumption-period-selector',
  template: require('./sim-consumption-period-selector.component.html'),
  styles: [require('./sim-consumption-period-selector.component.sass')],

})
export class SimConsumptionPeriodSelectorComponent implements OnInit, OnDestroy {

  @ViewChild('simPeriodExportModal') simPeriodExportModal: ElementRef;
  @Output() select = new EventEmitter<{
    dateFrom: string,
    dateTo: string
  }>();

  simPeriodExportForm: FormGroup;
  simPeriodExportModalReference: NgbModalRef;
  maxDateTime = new Date();
  dateFormat = "yy/mm/dd";

  languageChangeSubscription: Subscription;
  locale = environment.calendar.locales['en'];
  
  constructor(
    private fb: FormBuilder,
    private modalService: NgbModal,
    private translate: TranslateService,
    @Inject("TimeZoneFactory") private timeZoneFactory: any
  ) {
    this.locale = environment.calendar.locales[this.translate.currentLang];
    this.simPeriodExportForm = this.fb.group({
      dateFrom: ['', [Validators.required]],
      dateTo: ['', [Validators.required]]
    });
    
    this.languageChangeSubscription = this.translate.onLangChange.subscribe(() => {
      this.locale = environment.calendar.locales[this.translate.currentLang];
    })
   }

  ngOnInit(): void {
  }

  async showModal() {
    this.simPeriodExportForm.patchValue({
        dateFrom:  new Date () ,
        dateTo: new Date ()
    });
    this.simPeriodExportModalReference = await this.modalService.open(this.simPeriodExportModal, {
      backdrop: 'static'
    });
  }

  save = () => {
    if (this.simPeriodExportForm.valid) {
      this.select.emit({
        dateFrom: this.timeZoneFactory
            .dateInCurrentTimeZone(nocUtil.beginAndEndOfDate ( this.simPeriodExportForm.value.dateFrom ).from)
            .format(),
        dateTo: this.timeZoneFactory
           .dateInCurrentTimeZone(nocUtil.beginAndEndOfDate ( this.simPeriodExportForm.value.dateTo ).to)
           .format()
      });
      this.simPeriodExportModalReference.close();
   } else {

   }
  }

  ngOnDestroy() {
    if (this.languageChangeSubscription) {
      this.languageChangeSubscription.unsubscribe();
    }
  }
}
